import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PurchaseService, Offer } from '../services/purchase.service';
import { environment } from '../../environments/environment'; // wherever apiAssetUrl lives

@Component({
  selector: 'app-purchase',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css'],
})
export class PurchaseComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private purchases = inject(PurchaseService);

    private apiBaseUrl: string = environment.apiBaseUrl;
    protected apiAssetUrl = this.apiBaseUrl + '/proxy/api/view-asset/';
    assetId = '';
    offer?: Offer;

  usePhone = false;
  email = '';
  phone = '';
  busy = false;
  error = '';

  ngOnInit() {
    this.assetId = this.route.snapshot.paramMap.get('assetId') ?? '';
    this.purchases.getOffer().subscribe((o) => (this.offer = o));
  }

  get priceLabel() {
    return this.offer
      ? new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.offer.currency })
          .format(this.offer.priceOre / 100)
      : '';
  }

  // toggleContact() {
  //   this.usePhone = !this.usePhone;
  //   this.error = '';
  // }

  pay() {
    this.error = '';
    // const contact = this.usePhone ? { phone: this.phone.trim() } : { email: this.email.trim() };
    const contact =  { email: this.email.trim() };
    // if (!contact.email && !contact.phone) {
    //   this.error = this.usePhone ? 'Enter your mobile number.' : 'Enter your email address.';
    //   return;
    // }

    this.busy = true;
    this.purchases.start(this.assetId, contact).subscribe({
      // Full-page redirect: Vipps MobilePay opens the app or its landing page,
      // then sends the buyer back to /purchase/complete?ref=...
      next: ({ redirectUrl }) => (window.location.href = redirectUrl),
      error: (err) => {
        this.busy = false;
        this.error = err?.error?.error ?? 'Noget gik galt - prøv igen.';
      },
    });
  }
}
